import { NgModule } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';

import { ChatbotTableComponent } from './chatbot-table/chatbot-table.component';
import { ChatbotDialogComponent } from './chatbot-dialog/chatbot-dialog.component';

@NgModule({
    declarations: [ChatbotTableComponent,ChatbotDialogComponent
    ],
    imports: [
        CommonModule,
        MatTableModule,
        MatPaginatorModule
    ],
    exports: [ChatbotTableComponent,ChatbotDialogComponent
    ]
})
export class SharedComponentsModule { }
